;(function () {
  'use strict'

  angular
    .module('contrast.settings.user.tsv')
    .constant('TSV_NOTIFICATION_PROVIDER', {
      GOOGLE: 'GOOGLE',
      EMAIL: 'EMAIL'
    })
    .constant('TSV_DEVICE_ENUM', {
      ANDROID: 'Android',
      IPHONE: 'iPhone',
      BLACKBERRY: 'Blackberry'
    })
})()
